// extracted by mini-css-extract-plugin
module.exports = {"container":"search-module__container___1lVXW","icon":"search-module__icon___1oaeU"};